import React from 'react'
import JewellerySetting from '../components/JewellerySetting'

const DesignJewellery = () => {
    return (
        <>
            <JewellerySetting/>
        </>
    )
}

export default DesignJewellery